import requestMagicLink from 'src/screens/magic-link/request-magic-link';
export default requestMagicLink;
